
/// <reference path="../membershipManager.module.ts" />
module Meevo.Plugins.MembershipManager {
    class ChangeBillStatusModalController {

        static $inject = [
            "$filter",
            "$mdDialog",
            "$translate",
            "meevo.components.modal.ModalService",
            "modalTitle",
            "associatedBillsList",
            "paymentRequestId"
        ];

        constructor(
            protected $filter: angular.IFilterService,
            protected $mdDialog: angular.material.IDialogService,
            protected $translate: angular.translate.ITranslateService,
            protected modalService: Meevo.Components.Modal.IModalService,
            public modalTitle: string,
            public associatedBillsList: any,
            public paymentRequestId: string
        ) {
            
        }

        changeStatusToPaid = () => {
            this.$mdDialog.hide({status: true});
        }

        changeStatusToSuspended = () => {
            this.$mdDialog.hide({status: false});
        }

        cancel = () => {
            this.$mdDialog.hide();
        };
    }

    angular.module("meevo.plugins.membershipManager")
        .controller("meevo.plugins.membershipManager.ChangeBillStatusModalController", ChangeBillStatusModalController);
}